import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';
import { ModuloService } from '@app/core/modulo.service';
import { tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-module-name',
  template: `
    {{ renderValue }}
  `
})
export class ModuleNameComponent implements OnInit, ViewCell {
  @Input() value: any;
  @Input() rowData: any;

  public renderValue: string;

  constructor(private moduleService: ModuloService) {}

  ngOnInit() {
    const directName = this.rowData?.module?.name;
    if (directName) {
      this.renderValue = directName;
    }
    this.moduleService.data$
      .pipe(
        tap(data => {
          const match = data.find(
            item => String(item?.idModule) === String(this.value)
          );
          this.renderValue = match?.name || this.value;
        })
      )
      .subscribe();
  }
}
